import axiosUtils from "../utils/axios";

const isEnabled = async (flagName: string): Promise<boolean> => {
    var result = await axiosUtils.instance.get<boolean>("api/frontendFeatureFlag", { params: { flagName } });
    return result.data;
}

export default {
    isEnabled
}
